import React, { useCallback, useEffect, useMemo, useState } from "react";

import { useFilters } from "@/providers/FiltersProvider";
import { ICommonFilter, IMainFilterChildren } from "@/types/Filters";

interface IRadioFilter {
    data: IMainFilterChildren
}
function RadioFilter({ data }: IRadioFilter) {
    const { tempFilters, setTempFilters } = useFilters();
    const [selectedItem, setSelectedItem] = useState<string | undefined>();

    useEffect(() => {
        const value = tempFilters?.[data.id]?.data?.[0]?.value;
        if (value) {
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setSelectedItem(value);
        }
    }, [data.id, tempFilters]);
    const filterData: ICommonFilter[] = useMemo(() => {
        if (data.data) {
            return data.data;
        }
        return [];
    }, [data.data]);

    const handleOnChange = useCallback((item: ICommonFilter) => {
        const newFilter = {
            ...tempFilters,
            [data.id]: {
                data: [{
                    value: item.value,
                    label: item.label,
                }],
            },
        };
        setTempFilters(newFilter);
        setSelectedItem(item.value);
    }, [data.id, tempFilters, setTempFilters]);

    return (
        <div className='radioItems'>
            {filterData.map((item) => (
                <div className='radioBox' key={item.value}>
                    <input type="radio"
                        id={item.label + item.value}
                        name={item.label}
                        value={item.value}
                        checked={selectedItem === item.value}
                        onChange={() => handleOnChange(item)} />
                    <label htmlFor={item.label + item.value}>{item.label}</label>
                </div>
            ))}
        </div>
    );
}

export default RadioFilter;
